/**
 * 插件目录plugins
 * 
 * require.context(directory, useSubdirectories, regExp) 是一个 webpack 的 api，自动导入文件
 * @param directory 检索的目录
 * @param useSubdirectories 是否检索子文件夹
 * @param regExp 匹配文件的正则表达式,一般是文件名
 */

const requirePlugin = require.context('/', false, /.+\.js$/)
requirePlugin.keys().forEach(fileName => {
    requirePlugin(fileName)
})